import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { mergeStyles } from '@uifabric/merge-styles';
import { getPalette } from 'owa-theme';

export default function getRemoveRecipientButtonStyle(colorScheme: ColorScheme) {
    const hoverColor = colorScheme ? colorScheme.calDarker : getPalette().themeDarker;

    return mergeStyles({
        selectors: {
            ':hover': { color: hoverColor },
            ':active': { color: hoverColor },
        },
    });
}
